import {AxiosError} from 'axios';
import {GET_ARRANGEMENT_OUTCOME_PDF} from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
interface GetArrangementOutcomeRequest {
  fileKey: string;
}

interface GetArrangementOutcomeResponse {
  url: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: GetArrangementOutcomeResponse) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const useGetArrangementOutcomePDF = ({onSuccess, onError}: Input = {}) => {
  const getArrangementOutcomePDF = async (reqBody: GetArrangementOutcomeRequest) => {
    const res = await axiosClient.get<GetArrangementOutcomeResponse>(
        GET_ARRANGEMENT_OUTCOME_PDF(reqBody.fileKey)
    );

    return res.data;
  };

  return useCustomMutation(getArrangementOutcomePDF, {
    onSuccess,
    onError,
  });
};
